<template>
  <div class="content" id="diagnostic">
    <div class="pendingLayer" v-if="isSubmitted">
      <div class="content">
        <h1 class="has-text-white has-text-weight-bold">
          Your submission has been received! When all participants have submitted their scores, you will receive a message to access the team scores.
        </h1>
      </div>
    </div>
    <div class="is-fullhd" style="margin-bottom: 1rem;">
      <div class="columns is-centered">
        <div class="column is-6">
          <div class="content progress-result has-text-right">
            <strong class="has-text-primary">{{currentStep}}</strong> out of <strong class="has-text-primary">{{totalSteps}}</strong>
            <progress class="progress is-primary" :value="currentStep" :max="totalSteps"></progress>
          </div>
        </div>
      </div>
    </div>
    <div class="is-fullhd">
      <div class="columns is-centered">
        <div class="column is-6">
          <div class="box">
            <div v-if="step === 1">
              <div class="column">
                <div class="content">
                  <h5 class="has-text-primary">
                    Change risk factor
                  </h5>
                </div>
                <div class="content">
                  <h4 class="has-text-weight-semibold has-text-justified">
                    {{ risks[0].question}}
                  </h4>
                </div>

                <div class="content">
                  <div class="box">
                    <div class="columns is-vcentered">
                      <div class="column is-9 secSlider">
                        <slider class="diagSlider" type="success" :value="parseFloat(identifySponsor)" :min="1" :max="9" :step=".5" is-fullwidth @change="update1"></slider>
                        <div class="diagSliderLabel">
                          <span class=''>1</span>
                          <span class=''>3</span>
                          <span class=''>5</span>
                          <span class=''>7</span>
                          <span class=''>9</span>
                        </div>
                      </div>

                      <div class="column is-3" style="padding-top: 0px;">
                        <input class="input"
                          type="number"
                          v-model="identifySponsor"
                          min="1" max="9" step=".5"
                          value="" onkeyup="this.value > 9 ? this.value = this.value.slice(0, -1) : true" v-focus/>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column content progress-btn is-hidden-tablet">
                  <div class="buttons" :class="{ 'btnRight' : currentStep === 1 }">
                    <button v-if="currentStep > 1" @click.prevent="prev()" class="button is-light"><i class="fa fa-chevron-left"></i>&nbsp;Back</button>
                    <button v-if="currentStep < totalSteps" @click.prevent="next()" class="button is-primary">Next &nbsp;<i class="fa fa-chevron-right"></i></button>
                    <button v-if="currentStep === totalSteps" @click.prevent="submit()" class="button is-primary">Submit</button>
                  </div>
                </div>
                
                <div class="columns is-mobile">
                  <div class="column is-half-mobile is-one-third-desktop is-paddingless legend">
                    <Label>Legend</Label>
                    <ul class='legend-labels'>
                      <li>1 - 3 <span class="colorGreen"></span><strong> Low Risk</strong></li>
                      <li>4 - 6 <span class="colorYellow"></span><strong> Medium Risk</strong></li>
                      <li>7 - 9 <span class="colorRed"></span><strong> High Risk</strong></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="step === 2">
              <div class="column">
                <div class="content">
                  <h5 class="has-text-primary">
                    Change risk factor
                  </h5>
                </div>
                <div class="content">
                  <h4 class="has-text-weight-semibold has-text-justified">
                    {{ risks[1].question}}
                  </h4>
                </div>

                <div class="content">
                  <div class="box">
                    <div class="columns is-vcentered">
                      <div class="column is-9 secSlider">
                        <slider class="diagSlider" type="success" :value="parseFloat(visionClarity)" :min="1" :max="9" :step=".5" is-fullwidth @change="update2"></slider>
                        <div class="diagSliderLabel">
                          <span class=''>1</span>
                          <span class=''>3</span>
                          <span class=''>5</span>
                          <span class=''>7</span>
                          <span class=''>9</span>
                        </div>
                      </div>

                      <div class="column is-3" style="padding-top: 0px;">
                        <input class="input"
                          type="number"
                          v-model="visionClarity"
                          min="1" max="9" step=".5"
                          value="" onkeyup="this.value > 9 ? this.value = this.value.slice(0, -1) : true" v-focus/>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column content progress-btn is-hidden-tablet">
                  <div class="buttons" :class="{ 'btnRight' : currentStep === 1 }">
                    <button v-if="currentStep > 1" @click.prevent="prev()" class="button is-light"><i class="fa fa-chevron-left"></i>&nbsp;Back</button>
                    <button v-if="currentStep < totalSteps" @click.prevent="next()" class="button is-primary">Next &nbsp;<i class="fa fa-chevron-right"></i></button>
                    <button v-if="currentStep === totalSteps" @click.prevent="submit()" class="button is-primary">Submit</button>
                  </div>
                </div>
                
                <div class="columns is-mobile">
                  <div class="column is-half-mobile is-one-third-desktop is-paddingless legend">
                    <Label>Legend</Label>
                    <ul class='legend-labels'>
                      <li>1 - 3 <span class="colorGreen"></span><strong> Low Risk</strong></li>
                      <li>4 - 6 <span class="colorYellow"></span><strong> Medium Risk</strong></li>
                      <li>7 - 9 <span class="colorRed"></span><strong> High Risk</strong></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="step === 3">
              <div class="column">
                <div class="content">
                  <h5 class="has-text-primary">
                    Change risk factor
                  </h5>
                </div>
                <div class="content">
                  <h4 class="has-text-weight-semibold has-text-justified">
                    {{ risks[2].question}}
                  </h4>
                </div>

                <div class="content">
                  <div class="box">
                    <div class="columns is-vcentered">
                      <div class="column is-9 secSlider">
                        <slider class="diagSlider" type="success" :value="parseFloat(sponsoringCoalition)" :min="1" :max="9" :step=".5" is-fullwidth @change="update3"></slider>
                        <div class="diagSliderLabel">
                          <span class=''>1</span>
                          <span class=''>3</span>
                          <span class=''>5</span>
                          <span class=''>7</span>
                          <span class=''>9</span>
                        </div>
                      </div>

                      <div class="column is-3" style="padding-top: 0px;">
                        <input class="input"
                          type="number"
                          v-model="sponsoringCoalition"
                          min="1" max="9" step=".5"
                          value="" onkeyup="this.value > 9 ? this.value = this.value.slice(0, -1) : true" v-focus/>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column content progress-btn is-hidden-tablet">
                  <div class="buttons" :class="{ 'btnRight' : currentStep === 1 }">
                    <button v-if="currentStep > 1" @click.prevent="prev()" class="button is-light"><i class="fa fa-chevron-left"></i>&nbsp;Back</button>
                    <button v-if="currentStep < totalSteps" @click.prevent="next()" class="button is-primary">Next &nbsp;<i class="fa fa-chevron-right"></i></button>
                    <button v-if="currentStep === totalSteps" @click.prevent="submit()" class="button is-primary">Submit</button>
                  </div>
                </div>
                
                <div class="columns is-mobile">
                  <div class="column is-half-mobile is-one-third-desktop is-paddingless legend">
                    <Label>Legend</Label>
                    <ul class='legend-labels'>
                      <li>1 - 3 <span class="colorGreen"></span><strong> Low Risk</strong></li>
                      <li>4 - 6 <span class="colorYellow"></span><strong> Medium Risk</strong></li>
                      <li>7 - 9 <span class="colorRed"></span><strong> High Risk</strong></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="step === 4">
              <div class="column">
                <div class="content">
                  <h5 class="has-text-primary">
                    Change risk factor
                  </h5>
                </div>
                <div class="content">
                  <h4 class="has-text-weight-semibold has-text-justified">
                    {{ risks[3].question}}
                  </h4>
                </div>

                <div class="content">
                  <div class="box">
                    <div class="columns is-vcentered">
                      <div class="column is-9 secSlider">
                        <slider class="diagSlider" type="success" :value="parseFloat(sponsorCapability)" :min="1" :max="9" :step=".5" is-fullwidth @change="update4"></slider>
                        <div class="diagSliderLabel">
                          <span class=''>1</span>
                          <span class=''>3</span>
                          <span class=''>5</span>
                          <span class=''>7</span>
                          <span class=''>9</span>
                        </div>
                      </div>

                      <div class="column is-3" style="padding-top: 0px;">
                        <input class="input"
                          type="number"
                          v-model="sponsorCapability"
                          min="1" max="9" step=".5"
                          value="" onkeyup="this.value > 9 ? this.value = this.value.slice(0, -1) : true" v-focus/>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column content progress-btn is-hidden-tablet">
                  <div class="buttons" :class="{ 'btnRight' : currentStep === 1 }">
                    <button v-if="currentStep > 1" @click.prevent="prev()" class="button is-light"><i class="fa fa-chevron-left"></i>&nbsp;Back</button>
                    <button v-if="currentStep < totalSteps" @click.prevent="next()" class="button is-primary">Next &nbsp;<i class="fa fa-chevron-right"></i></button>
                    <button v-if="currentStep === totalSteps" @click.prevent="submit()" class="button is-primary">Submit</button>
                  </div>
                </div>
                
                <div class="columns is-mobile">
                  <div class="column is-half-mobile is-one-third-desktop is-paddingless legend">
                    <Label>Legend</Label>
                    <ul class='legend-labels'>
                      <li>1 - 3 <span class="colorGreen"></span><strong> Low Risk</strong></li>
                      <li>4 - 6 <span class="colorYellow"></span><strong> Medium Risk</strong></li>
                      <li>7 - 9 <span class="colorRed"></span><strong> High Risk</strong></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="step === 5">
              <div class="column">
                <div class="content">
                  <h5 class="has-text-primary">
                    Change risk factor
                  </h5>
                </div>
                <div class="content">
                  <h4 class="has-text-weight-semibold has-text-justified">
                    {{ risks[4].question}}
                  </h4>
                </div>

                <div class="content">
                  <div class="box">
                    <div class="columns is-vcentered">
                      <div class="column is-9 secSlider">
                        <slider class="diagSlider" type="success" :value="parseFloat(governance)" :min="1" :max="9" :step=".5" is-fullwidth @change="update5"></slider>
                        <div class="diagSliderLabel">
                          <span class=''>1</span>
                          <span class=''>3</span>
                          <span class=''>5</span>
                          <span class=''>7</span>
                          <span class=''>9</span>
                        </div>
                      </div>

                      <div class="column is-3" style="padding-top: 0px;">
                        <input class="input"
                          type="number"
                          v-model="governance"
                          min="1" max="9" step=".5"
                          value="" onkeyup="this.value > 9 ? this.value = this.value.slice(0, -1) : true" v-focus/>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column content progress-btn is-hidden-tablet">
                  <div class="buttons" :class="{ 'btnRight' : currentStep === 1 }">
                    <button v-if="currentStep > 1" @click.prevent="prev()" class="button is-light"><i class="fa fa-chevron-left"></i>&nbsp;Back</button>
                    <button v-if="currentStep < totalSteps" @click.prevent="next()" class="button is-primary">Next &nbsp;<i class="fa fa-chevron-right"></i></button>
                    <button v-if="currentStep === totalSteps" @click.prevent="submit()" class="button is-primary">Submit</button>
                  </div>
                </div>
                
                <div class="columns is-mobile">
                  <div class="column is-half-mobile is-one-third-desktop is-paddingless legend">
                    <Label>Legend</Label>
                    <ul class='legend-labels'>
                      <li>1 - 3 <span class="colorGreen"></span><strong> Low Risk</strong></li>
                      <li>4 - 6 <span class="colorYellow"></span><strong> Medium Risk</strong></li>
                      <li>7 - 9 <span class="colorRed"></span><strong> High Risk</strong></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="step === 6">
              <div class="column">
                <div class="content">
                  <h5 class="has-text-primary">
                    Change risk factor
                  </h5>
                </div>
                <div class="content">
                  <h4 class="has-text-weight-semibold has-text-justified">
                   {{ risks[5].question}}
                  </h4>
                </div>

                <div class="content">
                  <div class="box">
                    <div class="columns is-vcentered">
                      <div class="column is-9 secSlider">
                        <slider class="diagSlider" type="success" :value="parseFloat(programmeManagement)" :min="1" :max="9" :step=".5" is-fullwidth @change="update6"></slider>
                        <div class="diagSliderLabel">
                          <span class=''>1</span>
                          <span class=''>3</span>
                          <span class=''>5</span>
                          <span class=''>7</span>
                          <span class=''>9</span>
                        </div>
                      </div>

                      <div class="column is-3" style="padding-top: 0px;">
                        <input class="input"
                          type="number"
                          v-model="programmeManagement"
                          min="1" max="9" step=".5"
                          value="" onkeyup="this.value > 9 ? this.value = this.value.slice(0, -1) : true" v-focus/>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column content progress-btn is-hidden-tablet">
                  <div class="buttons" :class="{ 'btnRight' : currentStep === 1 }">
                    <button v-if="currentStep > 1" @click.prevent="prev()" class="button is-light"><i class="fa fa-chevron-left"></i>&nbsp;Back</button>
                    <button v-if="currentStep < totalSteps" @click.prevent="next()" class="button is-primary">Next &nbsp;<i class="fa fa-chevron-right"></i></button>
                    <button v-if="currentStep === totalSteps" @click.prevent="submit()" class="button is-primary">Submit</button>
                  </div>
                </div>
                
                <div class="columns is-mobile">
                  <div class="column is-half-mobile is-one-third-desktop is-paddingless legend">
                    <Label>Legend</Label>
                    <ul class='legend-labels'>
                      <li>1 - 3 <span class="colorGreen"></span><strong> Low Risk</strong></li>
                      <li>4 - 6 <span class="colorYellow"></span><strong> Medium Risk</strong></li>
                      <li>7 - 9 <span class="colorRed"></span><strong> High Risk</strong></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="step === 7">
              <div class="column">
                <div class="content">
                  <h5 class="has-text-primary">
                    Change risk factor
                  </h5>
                </div>
                <div class="content">
                  <h4 class="has-text-weight-semibold has-text-justified">
                    {{ risks[6].question}}
                  </h4>
                </div>

                <div class="content">
                  <div class="box">
                    <div class="columns is-vcentered">
                      <div class="column is-9 secSlider">
                        <slider class="diagSlider" type="success" :value="parseFloat(budgetingandResourcing)" :min="1" :max="9" :step=".5" is-fullwidth @change="update7"></slider>
                        <div class="diagSliderLabel">
                          <span class=''>1</span>
                          <span class=''>3</span>
                          <span class=''>5</span>
                          <span class=''>7</span>
                          <span class=''>9</span>
                        </div>
                      </div>

                      <div class="column is-3" style="padding-top: 0px;">
                        <input class="input"
                          type="number"
                          v-model="budgetingandResourcing"
                          min="1" max="9" step=".5"
                          value="" onkeyup="this.value > 9 ? this.value = this.value.slice(0, -1) : true" v-focus/>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column content progress-btn is-hidden-tablet">
                  <div class="buttons" :class="{ 'btnRight' : currentStep === 1 }">
                    <button v-if="currentStep > 1" @click.prevent="prev()" class="button is-light"><i class="fa fa-chevron-left"></i>&nbsp;Back</button>
                    <button v-if="currentStep < totalSteps" @click.prevent="next()" class="button is-primary">Next &nbsp;<i class="fa fa-chevron-right"></i></button>
                    <button v-if="currentStep === totalSteps" @click.prevent="submit()" class="button is-primary">Submit</button>
                  </div>
                </div>
                
                <div class="columns is-mobile">
                  <div class="column is-half-mobile is-one-third-desktop is-paddingless legend">
                    <Label>Legend</Label>
                    <ul class='legend-labels'>
                      <li>1 - 3 <span class="colorGreen"></span><strong> Low Risk</strong></li>
                      <li>4 - 6 <span class="colorYellow"></span><strong> Medium Risk</strong></li>
                      <li>7 - 9 <span class="colorRed"></span><strong> High Risk</strong></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="step === 8">
              <div class="column">
                <div class="content">
                  <h5 class="has-text-primary">
                    Change risk factor
                  </h5>
                </div>
                <div class="content">
                  <h4 class="has-text-weight-semibold has-text-justified">
                    {{ risks[7].question}}
                  </h4>
                </div>

                <div class="content">
                  <div class="box">
                    <div class="columns is-vcentered">
                      <div class="column is-9 secSlider">
                        <slider class="diagSlider" type="success" :value="parseFloat(programmeDelivery)" :min="1" :max="9" :step=".5" is-fullwidth @change="update8"></slider>
                        <div class="diagSliderLabel">
                          <span class=''>1</span>
                          <span class=''>3</span>
                          <span class=''>5</span>
                          <span class=''>7</span>
                          <span class=''>9</span>
                        </div>
                      </div>

                      <div class="column is-3" style="padding-top: 0px;">
                        <input class="input"
                          type="number"
                          v-model="programmeDelivery"
                          min="1" max="9" step=".5"
                          value="" onkeyup="this.value > 9 ? this.value = this.value.slice(0, -1) : true" v-focus/>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column content progress-btn is-hidden-tablet">
                  <div class="buttons" :class="{ 'btnRight' : currentStep === 1 }">
                    <button v-if="currentStep > 1" @click.prevent="prev()" class="button is-light"><i class="fa fa-chevron-left"></i>&nbsp;Back</button>
                    <button v-if="currentStep < totalSteps" @click.prevent="next()" class="button is-primary">Next &nbsp;<i class="fa fa-chevron-right"></i></button>
                    <button v-if="currentStep === totalSteps" @click.prevent="submit()" class="button is-primary">Submit</button>
                  </div>
                </div>
                
                <div class="columns is-mobile">
                  <div class="column is-half-mobile is-one-third-desktop is-paddingless legend">
                    <Label>Legend</Label>
                    <ul class='legend-labels'>
                      <li>1 - 3 <span class="colorGreen"></span><strong> Low Risk</strong></li>
                      <li>4 - 6 <span class="colorYellow"></span><strong> Medium Risk</strong></li>
                      <li>7 - 9 <span class="colorRed"></span><strong> High Risk</strong></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="step === 9">
              <div class="column">
                <div class="content">
                  <h5 class="has-text-primary">
                    Change risk factor
                  </h5>
                </div>
                <div class="content">
                  <h4 class="has-text-weight-semibold has-text-justified">
                    {{ risks[8].question}}
                  </h4>
                </div>

                <div class="content">
                  <div class="box">
                    <div class="columns is-vcentered">
                      <div class="column is-9 secSlider">
                        <slider class="diagSlider" type="success" :value="parseFloat(businessRequirements)" :min="1" :max="9" :step=".5" is-fullwidth @change="update9"></slider>
                        <div class="diagSliderLabel">
                          <span class=''>1</span>
                          <span class=''>3</span>
                          <span class=''>5</span>
                          <span class=''>7</span>
                          <span class=''>9</span>
                        </div>
                      </div>

                      <div class="column is-3" style="padding-top: 0px;">
                        <input class="input"
                          type="number"
                          v-model="businessRequirements"
                          min="1" max="9" step=".5"
                          value="" onkeyup="this.value > 9 ? this.value = this.value.slice(0, -1) : true" v-focus/>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column content progress-btn is-hidden-tablet">
                  <div class="buttons" :class="{ 'btnRight' : currentStep === 1 }">
                    <button v-if="currentStep > 1" @click.prevent="prev()" class="button is-light"><i class="fa fa-chevron-left"></i>&nbsp;Back</button>
                    <button v-if="currentStep < totalSteps" @click.prevent="next()" class="button is-primary">Next &nbsp;<i class="fa fa-chevron-right"></i></button>
                    <button v-if="currentStep === totalSteps" @click.prevent="submit()" class="button is-primary">Submit</button>
                  </div>
                </div>
                
                <div class="columns is-mobile">
                  <div class="column is-half-mobile is-one-third-desktop is-paddingless legend">
                    <Label>Legend</Label>
                    <ul class='legend-labels'>
                      <li>1 - 3 <span class="colorGreen"></span><strong> Low Risk</strong></li>
                      <li>4 - 6 <span class="colorYellow"></span><strong> Medium Risk</strong></li>
                      <li>7 - 9 <span class="colorRed"></span><strong> High Risk</strong></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="step === 10">
              <div class="column">
                <div class="content">
                  <h5 class="has-text-primary">
                    Change risk factor
                  </h5>
                </div>
                <div class="content">
                  <h4 class="has-text-weight-semibold has-text-justified">
                    {{ risks[9].question}}
                  </h4>
                </div>

                <div class="content">
                  <div class="box">
                    <div class="columns is-vcentered">
                      <div class="column is-9 secSlider">
                        <slider class="diagSlider" type="success" :value="parseFloat(organizationDesign)" :min="1" :max="9" :step=".5" is-fullwidth @change="update10"></slider>
                        <div class="diagSliderLabel">
                          <span class=''>1</span>
                          <span class=''>3</span>
                          <span class=''>5</span>
                          <span class=''>7</span>
                          <span class=''>9</span>
                        </div>
                      </div>

                      <div class="column is-3" style="padding-top: 0px;">
                        <input class="input"
                          type="number"
                          v-model="organizationDesign"
                          min="1" max="9" step=".5"
                          value="" onkeyup="this.value > 9 ? this.value = this.value.slice(0, -1) : true" v-focus/>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column content progress-btn is-hidden-tablet">
                  <div class="buttons" :class="{ 'btnRight' : currentStep === 1 }">
                    <button v-if="currentStep > 1" @click.prevent="prev()" class="button is-light"><i class="fa fa-chevron-left"></i>&nbsp;Back</button>
                    <button v-if="currentStep < totalSteps" @click.prevent="next()" class="button is-primary">Next &nbsp;<i class="fa fa-chevron-right"></i></button>
                    <button v-if="currentStep === totalSteps" @click.prevent="submit()" class="button is-primary">Submit</button>
                  </div>
                </div>
                
                <div class="columns is-mobile">
                  <div class="column is-half-mobile is-one-third-desktop is-paddingless legend">
                    <Label>Legend</Label>
                    <ul class='legend-labels'>
                      <li>1 - 3 <span class="colorGreen"></span><strong> Low Risk</strong></li>
                      <li>4 - 6 <span class="colorYellow"></span><strong> Medium Risk</strong></li>
                      <li>7 - 9 <span class="colorRed"></span><strong> High Risk</strong></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="step === 11">
              <div class="column">
                <div class="content">
                  <h5 class="has-text-primary">
                    Change risk factor
                  </h5>
                </div>
                <div class="content">
                  <h4 class="has-text-weight-semibold has-text-justified">
                    {{ risks[10].question}}
                  </h4>
                </div>

                <div class="content">
                  <div class="box">
                    <div class="columns is-vcentered">
                      <div class="column is-9 secSlider">
                        <slider class="diagSlider" type="success" :value="parseFloat(changeReadiness)" :min="1" :max="9" :step=".5" is-fullwidth @change="update11"></slider>
                        <div class="diagSliderLabel">
                          <span class=''>1</span>
                          <span class=''>3</span>
                          <span class=''>5</span>
                          <span class=''>7</span>
                          <span class=''>9</span>
                        </div>
                      </div>

                      <div class="column is-3" style="padding-top: 0px;">
                        <input class="input"
                          type="number"
                          v-model="changeReadiness"
                          min="1" max="9" step=".5"
                          value="" onkeyup="this.value > 9 ? this.value = this.value.slice(0, -1) : true" v-focus/>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column content progress-btn is-hidden-tablet">
                  <div class="buttons" :class="{ 'btnRight' : currentStep === 1 }">
                    <button v-if="currentStep > 1" @click.prevent="prev()" class="button is-light"><i class="fa fa-chevron-left"></i>&nbsp;Back</button>
                    <button v-if="currentStep < totalSteps" @click.prevent="next()" class="button is-primary">Next &nbsp;<i class="fa fa-chevron-right"></i></button>
                    <button v-if="currentStep === totalSteps" @click.prevent="submit()" class="button is-primary">Submit</button>
                  </div>
                </div>
                
                <div class="columns is-mobile">
                  <div class="column is-half-mobile is-one-third-desktop is-paddingless legend">
                    <Label>Legend</Label>
                    <ul class='legend-labels'>
                      <li>1 - 3 <span class="colorGreen"></span><strong> Low Risk</strong></li>
                      <li>4 - 6 <span class="colorYellow"></span><strong> Medium Risk</strong></li>
                      <li>7 - 9 <span class="colorRed"></span><strong> High Risk</strong></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="step === 12">
              <div class="column">
                <div class="content">
                  <h5 class="has-text-primary">
                    Change risk factor
                  </h5>
                </div>
                <div class="content">
                  <h4 class="has-text-weight-semibold has-text-justified">
                    {{ risks[11].question}}
                  </h4>
                </div>

                <div class="content">
                  <div class="box">
                    <div class="columns is-vcentered">
                      <div class="column is-9 secSlider">
                        <slider class="diagSlider" type="success" :value="parseFloat(implementationPlanning)" :min="1" :max="9" :step=".5" is-fullwidth @change="update12"></slider>
                        <div class="diagSliderLabel">
                          <span class=''>1</span>
                          <span class=''>3</span>
                          <span class=''>5</span>
                          <span class=''>7</span>
                          <span class=''>9</span>
                        </div>
                      </div>

                      <div class="column is-3" style="padding-top: 0px;">
                        <input class="input"
                          type="number"
                          v-model="implementationPlanning"
                          min="1" max="9" step=".5"
                          value="" onkeyup="this.value > 9 ? this.value = this.value.slice(0, -1) : true" v-focus/>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column content progress-btn is-hidden-tablet">
                  <div class="buttons" :class="{ 'btnRight' : currentStep === 1 }">
                    <button v-if="currentStep > 1" @click.prevent="prev()" class="button is-light"><i class="fa fa-chevron-left"></i>&nbsp;Back</button>
                    <button v-if="currentStep < totalSteps" @click.prevent="next()" class="button is-primary">Next &nbsp;<i class="fa fa-chevron-right"></i></button>
                    <button v-if="currentStep === totalSteps" @click.prevent="submit()" class="button is-primary">Submit</button>
                  </div>
                </div>
                
                <div class="columns is-mobile">
                  <div class="column is-half-mobile is-one-third-desktop is-paddingless legend">
                    <Label>Legend</Label>
                    <ul class='legend-labels'>
                      <li>1 - 3 <span class="colorGreen"></span><strong> Low Risk</strong></li>
                      <li>4 - 6 <span class="colorYellow"></span><strong> Medium Risk</strong></li>
                      <li>7 - 9 <span class="colorRed"></span><strong> High Risk</strong></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="step === 13">
              <div class="column">
                <div class="content">
                  <h5 class="has-text-primary">
                    Change risk factor
                  </h5>
                </div>
                <div class="content">
                  <h4 class="has-text-weight-semibold has-text-justified">
                   {{ risks[12].question}}
                  </h4>
                </div>

                <div class="content">
                  <div class="box">
                    <div class="columns is-vcentered">
                      <div class="column is-9 secSlider">
                        <slider class="diagSlider" type="success" :value="parseFloat(changeLeadership)" :min="1" :max="9" :step=".5" is-fullwidth @change="update13"></slider>
                        <div class="diagSliderLabel">
                          <span class=''>1</span>
                          <span class=''>3</span>
                          <span class=''>5</span>
                          <span class=''>7</span>
                          <span class=''>9</span>
                        </div>
                      </div>

                      <div class="column is-3" style="padding-top: 0px;">
                        <input class="input"
                          type="number"
                          v-model="changeLeadership"
                          min="1" max="9" step=".5"
                          value="" onkeyup="this.value > 9 ? this.value = this.value.slice(0, -1) : true" v-focus/>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column content progress-btn is-hidden-tablet">
                  <div class="buttons" :class="{ 'btnRight' : currentStep === 1 }">
                    <button v-if="currentStep > 1" @click.prevent="prev()" class="button is-light"><i class="fa fa-chevron-left"></i>&nbsp;Back</button>
                    <button v-if="currentStep < totalSteps" @click.prevent="next()" class="button is-primary">Next &nbsp;<i class="fa fa-chevron-right"></i></button>
                    <button v-if="currentStep === totalSteps" @click.prevent="submit()" class="button is-primary">Submit</button>
                  </div>
                </div>
                
                <div class="columns is-mobile">
                  <div class="column is-half-mobile is-one-third-desktop is-paddingless legend">
                    <Label>Legend</Label>
                    <ul class='legend-labels'>
                      <li>1 - 3 <span class="colorGreen"></span><strong> Low Risk</strong></li>
                      <li>4 - 6 <span class="colorYellow"></span><strong> Medium Risk</strong></li>
                      <li>7 - 9 <span class="colorRed"></span><strong> High Risk</strong></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="step === 14">
              <div class="column">
                <div class="content">
                  <h5 class="has-text-primary">
                    Change risk factor
                  </h5>
                </div>
                <div class="content">
                  <h4 class="has-text-weight-semibold has-text-justified">
                    {{ risks[13].question}}
                  </h4>
                </div>

                <div class="content">
                  <div class="box">
                    <div class="columns is-vcentered">
                      <div class="column is-9 secSlider">
                        <slider class="diagSlider" type="success" :value="parseFloat(stakeholderEngagement)" :min="1" :max="9" :step=".5" is-fullwidth @change="update14"></slider>
                        <div class="diagSliderLabel">
                          <span class=''>1</span>
                          <span class=''>3</span>
                          <span class=''>5</span>
                          <span class=''>7</span>
                          <span class=''>9</span>
                        </div>
                      </div>

                      <div class="column is-3" style="padding-top: 0px;">
                        <input class="input"
                          type="number"
                          v-model="stakeholderEngagement"
                          min="1" max="9" step=".5"
                          value="" onkeyup="this.value > 9 ? this.value = this.value.slice(0, -1) : true" v-focus/>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column content progress-btn is-hidden-tablet">
                  <div class="buttons" :class="{ 'btnRight' : currentStep === 1 }">
                    <button v-if="currentStep > 1" @click.prevent="prev()" class="button is-light"><i class="fa fa-chevron-left"></i>&nbsp;Back</button>
                    <button v-if="currentStep < totalSteps" @click.prevent="next()" class="button is-primary">Next &nbsp;<i class="fa fa-chevron-right"></i></button>
                    <button v-if="currentStep === totalSteps" @click.prevent="submit()" class="button is-primary">Submit</button>
                  </div>
                </div>
                
                <div class="columns is-mobile">
                  <div class="column is-half-mobile is-one-third-desktop is-paddingless legend">
                    <Label>Legend</Label>
                    <ul class='legend-labels'>
                      <li>1 - 3 <span class="colorGreen"></span><strong> Low Risk</strong></li>
                      <li>4 - 6 <span class="colorYellow"></span><strong> Medium Risk</strong></li>
                      <li>7 - 9 <span class="colorRed"></span><strong> High Risk</strong></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="step === 15">
              <div class="column">
                <div class="content">
                  <h5 class="has-text-primary">
                    Change risk factor
                  </h5>
                </div>
                <div class="content">
                  <h4 class="has-text-weight-semibold has-text-justified">
                    {{ risks[14].question}}
                  </h4>
                </div>

                <div class="content">
                  <div class="box">
                    <div class="columns is-vcentered">
                      <div class="column is-9 secSlider">
                        <slider class="diagSlider" type="success" :value="parseFloat(implementationCapability)" :min="1" :max="9" :step=".5" is-fullwidth @change="update15"></slider>
                        <div class="diagSliderLabel">
                          <span class=''>1</span>
                          <span class=''>3</span>
                          <span class=''>5</span>
                          <span class=''>7</span>
                          <span class=''>9</span>
                        </div>
                      </div>

                      <div class="column is-3" style="padding-top: 0px;">
                        <input class="input"
                          type="number"
                          v-model="implementationCapability"
                          min="1" max="9" step=".5"
                          value="" onkeyup="this.value > 9 ? this.value = this.value.slice(0, -1) : true" v-focus/>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column content progress-btn is-hidden-tablet">
                  <div class="buttons" :class="{ 'btnRight' : currentStep === 1 }">
                    <button v-if="currentStep > 1" @click.prevent="prev()" class="button is-light"><i class="fa fa-chevron-left"></i>&nbsp;Back</button>
                    <button v-if="currentStep < totalSteps" @click.prevent="next()" class="button is-primary">Next &nbsp;<i class="fa fa-chevron-right"></i></button>
                    <button v-if="currentStep === totalSteps" @click.prevent="submit()" class="button is-primary">Submit</button>
                  </div>
                </div>
                
                <div class="columns is-mobile">
                  <div class="column is-half-mobile is-one-third-desktop is-paddingless legend">
                    <Label>Legend</Label>
                    <ul class='legend-labels'>
                      <li>1 - 3 <span class="colorGreen"></span><strong> Low Risk</strong></li>
                      <li>4 - 6 <span class="colorYellow"></span><strong> Medium Risk</strong></li>
                      <li>7 - 9 <span class="colorRed"></span><strong> High Risk</strong></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="step === 16">
              <div class="column">
                <div class="content">
                  <h5 class="has-text-primary">
                    Change risk factor
                  </h5>
                </div>
                <div class="content">
                  <h4 class="has-text-weight-semibold has-text-justified">
                    {{ risks[15].question}}
                  </h4>
                </div>

                <div class="content">
                  <div class="box">
                    <div class="columns is-vcentered">
                      <div class="column is-9 secSlider">
                        <slider class="diagSlider" type="success" :value="parseFloat(supportPeoplesJournery)" :min="1" :max="9" :step=".5" is-fullwidth @change="update16"></slider>
                        <div class="diagSliderLabel">
                          <span class=''>1</span>
                          <span class=''>3</span>
                          <span class=''>5</span>
                          <span class=''>7</span>
                          <span class=''>9</span>
                        </div>
                      </div>

                      <div class="column is-3" style="padding-top: 0px;">
                        <input class="input"
                          type="number"
                          v-model="supportPeoplesJournery"
                          min="1" max="9" step=".5"
                          value="" onkeyup="this.value > 9 ? this.value = this.value.slice(0, -1) : true" v-focus/>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column content progress-btn is-hidden-tablet">
                  <div class="buttons" :class="{ 'btnRight' : currentStep === 1 }">
                    <button v-if="currentStep > 1" @click.prevent="prev()" class="button is-light"><i class="fa fa-chevron-left"></i>&nbsp;Back</button>
                    <button v-if="currentStep < totalSteps" @click.prevent="next()" class="button is-primary">Next &nbsp;<i class="fa fa-chevron-right"></i></button>
                    <button v-if="currentStep === totalSteps" @click.prevent="submit()" class="button is-primary">Submit</button>
                  </div>
                </div>
                
                <div class="columns is-mobile">
                  <div class="column is-half-mobile is-one-third-desktop is-paddingless legend">
                    <Label>Legend</Label>
                    <ul class='legend-labels'>
                      <li>1 - 3 <span class="colorGreen"></span><strong> Low Risk</strong></li>
                      <li>4 - 6 <span class="colorYellow"></span><strong> Medium Risk</strong></li>
                      <li>7 - 9 <span class="colorRed"></span><strong> High Risk</strong></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="column content progress-btn is-hidden-mobile">
              <div class="buttons" :class="{ 'btnRight' : currentStep === 1 }">
                <button v-if="currentStep > 1" @click.prevent="prev()" class="button is-light"><i class="fa fa-chevron-left"></i>&nbsp;Back</button>
                <button v-if="currentStep < totalSteps" @click.prevent="next()" class="button is-primary">Next &nbsp;<i class="fa fa-chevron-right"></i></button>
                <button v-if="currentStep === totalSteps" @click.prevent="submit()" class="button is-primary">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      
    <div class="modal successModal" :class="{ isActive: modalOpen }">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">
          <div class="content">
            <h2 class="is-title is-bold has-text-centered has-text-primary">
              Thank you!
            </h2>
            <button class="delete" aria-label="close" @click="closeModal()"></button>
          </div>
          <hr></hr>
          <p>
            Your submission has been received! When all participants have submitted their scores, you can access the team scores.
          </p>
          <!-- <p style="margin-top: 1rem;">
            You can return to edit your scores at any time before the due date for the assessment.
          </p> -->
          <p style="margin-top: 1rem;">
            Thank you for using ChangeVU!
          </p>
          <div class="has-text-centered" style="margin-top: 1rem;">
            <button @click="closeModal()" class="button is-primary">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'assets/scss/diagnostic.scss'
import router from '../../router'
import Slider from 'vue-bulma-slider'
import axios from 'axios'
import * as globalConstants from '../../globalConstants.js'

export default {
  components: {
    Slider
  },
  props: {
    value: String
  },
  data () {
    return {
      modalOpen: false,
      user: '',
      totalSteps: 16,
      currentStep: 1,
      step: 1,
      error: null,
      randomQuestion: [],
      risks: [
        {
          question: 'One sponsor has been clearly identified and is driving (or continues to drive) the Initiative/Project(s)',
          score: '',
          subcategory: 'identifySponsor'
        },
        {
          question: 'We have completed and communicated a business case that describes the Initiative/Project(s) including costs, benefits, rationale, interfaces, deliverables and milestones & timing for installation and adoption or uptake',
          score: '',
          subcategory: 'visionClarity'
        },
        {
          question: 'A clear line of accountability exists from lead Sponsor Project leaders, sufficient to deliver in the time frame envisioned over the lifespan of the implementation',
          score: '',
          subcategory: 'sponsoringCoalition'
        },
        {
          question: 'We have the appropriate and required change skills in key leadership roles to deliver the Initiative/Project(s)',
          score: '',
          subcategory: 'sponsorCapability'
        },
        {
          question: 'Our Initiative/Project(s) has the right Governance in place to ensure successful implementation (including steering and other supporting committees, decision-making criteria and process)',
          score: '',
          subcategory: 'governance'
        },
        {
          question: 'Our Program Office is fit-for-purpose to manage the implementation of the Initiative/Project(s) effectively (including staffing, skills, tools, resources and other project-specific support infrastructure)',
          score: '',
          subcategory: 'programmeManagement'
        },
        {
          question: 'We have all relevant Financing, Costing, Budgeting and allocation of Resources secured for the entire Initiative/Project(s) (including specialized skill-sets, variable, part-time and contract resources)',
          score: '',
          subcategory: 'budgetingandResourcing'
        },
        {
          question: 'Our Program delivery resourcing (including variable and part-time, contract staffing, etc.) and infrastructure is appropriate for the various needs of the Initiative/Project for all stages of implementation',
          score: '',
          subcategory: 'programmeDelivery'
        },
        {
          question: 'Our Initiative/Project(s) fits/is fully aligned with the existing business strategy and overall business goals of our organization',
          score: '',
          subcategory: 'businessRequirements'
        },
        {
          question: 'We have a clear description and definition of the "end state"/outcome of the Initiative/Project(s) in place (including organization design criteria, measurables, metrics & activities) ',
          score: '',
          subcategory: 'organizationDesign'
        },
        {
          question: 'We have the appropriate Change Readiness resources, skills and support in place to drive the activities, interventions, meetings and coordination to  support effective implementation of the Initiative/Project(s)',
          score: '',
          subcategory: 'changeReadiness'
        },
        {
          question: 'We have specific, differentiated communication activities for individual target communities in place (including role during various implementation phases, business impact, outcome, timeline etc.)',
          score: '',
          subcategory: 'implementationPlanning'
        },
        {
          question: 'We have the required experience and skills for leading the change in key management & supervisory positions for the Initiative/Project(s) in place',
          score: '',
          subcategory: 'changeLeadership'
        },
        {
          question: "Our key Stakeholder Engagement plan & process for Engagement with all key stakeholders (external and internal) fits the requirements to successfully deliver the Initiative/Project(s) over it's life-span",
          score: '',
          subcategory: 'stakeholderEngagement'
        },
        {
          question: 'We have the appropriate resourcing of skills and capabilities for people-related Change Management and Engagement in place',
          score: '',
          subcategory: 'implementationCapability'
        },
        {
          question: 'We have planned, resourced and are ready to deliver all the support and relevant materials required to ensure all impacted employees and other stakeholders (internal and external) are enabled to make the required Change and Transformation',
          score: '',
          subcategory: 'supportPeoplesJournery'
        }
      ],
      identifySponsor: '',
      visionClarity: '',
      sponsoringCoalition: '',
      sponsorCapability: '',
      governance: '',
      programmeManagement: '',
      budgetingandResourcing: '',
      programmeDelivery: '',
      businessRequirements: '',
      organizationDesign: '',
      changeReadiness: '',
      implementationPlanning: '',
      changeLeadership: '',
      stakeholderEngagement: '',
      implementationCapability: '',
      supportPeoplesJournery: '',
      isSubmitted: this.$store.state.assessmentCompleted
    }
  },
  methods: {
    prev () {
      this.currentStep--
      this.step = this.randomQuestion[this.currentStep - 1]
      this.isMobile = window.innerWidth < 1024
      if (this.isMobile) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    },
    next () {
      this.currentStep++
      this.step = this.randomQuestion[this.currentStep - 1]
      this.isMobile = window.innerWidth < 1024
      if (this.isMobile) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    },
    submit () {
      let allDone = false
      if (parseFloat(this.identifySponsor) > 0 && parseFloat(this.identifySponsor) < 10 &&
      parseFloat(this.visionClarity) > 0 && parseFloat(this.visionClarity) < 10 &&
      parseFloat(this.sponsoringCoalition) > 0 && parseFloat(this.sponsoringCoalition) < 10 &&
      parseFloat(this.sponsorCapability) > 0 && parseFloat(this.sponsorCapability) < 10 &&
      parseFloat(this.governance) > 0 && parseFloat(this.governance) < 10 &&
      parseFloat(this.programmeManagement) > 0 && parseFloat(this.programmeManagement) < 10 &&
      parseFloat(this.budgetingandResourcing) > 0 && parseFloat(this.budgetingandResourcing) < 10 &&
      parseFloat(this.programmeDelivery) > 0 && parseFloat(this.programmeDelivery) < 10 &&
      parseFloat(this.businessRequirements) > 0 && parseFloat(this.businessRequirements) < 10 &&
      parseFloat(this.organizationDesign) > 0 && parseFloat(this.organizationDesign) < 10 &&
      parseFloat(this.changeReadiness) > 0 && parseFloat(this.changeReadiness) < 10 &&
      parseFloat(this.implementationPlanning) > 0 && parseFloat(this.implementationPlanning) < 10 &&
      parseFloat(this.changeLeadership) > 0 && parseFloat(this.changeLeadership) < 10 &&
      parseFloat(this.stakeholderEngagement) > 0 && parseFloat(this.stakeholderEngagement) < 10 &&
      parseFloat(this.implementationCapability) > 0 && parseFloat(this.implementationCapability) < 10 &&
      parseFloat(this.supportPeoplesJournery) > 0 && parseFloat(this.supportPeoplesJournery) < 10) {
        allDone = true
      }
      if (allDone) {
        let message = 'You can not change your assessment score once submitted. Are you sure you want to submit this score?'
        let options = {
          loader: true,
          okText: 'Yes, submit my score',
          cancelText: 'No, do not submit my score',
          customClass: 'dg-diagnostics'
        }
        this.$dialog.confirm(message, options)
          .then(dialog => {
            axios.post(globalConstants.apiURL + '/api/v1/checkAllDone/' + this.initiativeId, {userID: this.user._id})
              .then(response => {
                this.$store.commit('setAssessmentCompleted', true)
                dialog.close()
                this.modalOpen = true
              })
              .catch(error => {
                console.log(error)
              })
          })
          .catch(() => {
          })
      } else {
        this.$noty.info('You must enter all change risk factors to complete this assessment.')
      }
    },
    closeModal () {
      this.modalOpen = false
      router.push({ path: '/assessment/myReport' })
    },
    update1 (val) {
      this.identifySponsor = val
      if (isNaN(val)) { val = '0' }
      axios.put(globalConstants.apiURL + '/api/v1/users/' + this.user._id, {initiativeId: this.initiativeId, riskValue: val, index: 0})
      .then(response => {
        this.user.diagonactics = response.data.diagonactics
        window.localStorage.setItem('user', JSON.stringify(this.user))
      })
      .catch(error => {
        console.log(error)
      })
    },
    update2 (val) {
      this.visionClarity = val
      if (isNaN(val)) { val = '0' }
      axios.put(globalConstants.apiURL + '/api/v1/users/' + this.user._id, {initiativeId: this.initiativeId, riskValue: val, index: 1})
      .then(response => {
        this.user.diagonactics = response.data.diagonactics
        window.localStorage.setItem('user', JSON.stringify(this.user))
      })
      .catch(error => {
        console.log(error)
      })
    },
    update3 (val) {
      this.sponsoringCoalition = val
      if (isNaN(val)) { val = '0' }
      axios.put(globalConstants.apiURL + '/api/v1/users/' + this.user._id, {initiativeId: this.initiativeId, riskValue: val, index: 2})
      .then(response => {
        this.user.diagonactics = response.data.diagonactics
        window.localStorage.setItem('user', JSON.stringify(this.user))
      })
      .catch(error => {
        console.log(error)
      })
    },
    update4 (val) {
      this.sponsorCapability = val
      if (isNaN(val)) { val = '0' }
      axios.put(globalConstants.apiURL + '/api/v1/users/' + this.user._id, {initiativeId: this.initiativeId, riskValue: val, index: 3})
      .then(response => {
        this.user.diagonactics = response.data.diagonactics
        window.localStorage.setItem('user', JSON.stringify(this.user))
      })
      .catch(error => {
        console.log(error)
      })
    },
    update5 (val) {
      this.governance = val
      if (isNaN(val)) { val = '0' }
      axios.put(globalConstants.apiURL + '/api/v1/users/' + this.user._id, {initiativeId: this.initiativeId, riskValue: val, index: 4})
      .then(response => {
        this.user.diagonactics = response.data.diagonactics
        window.localStorage.setItem('user', JSON.stringify(this.user))
      })
      .catch(error => {
        console.log(error)
      })
    },
    update6 (val) {
      this.programmeManagement = val
      if (isNaN(val)) { val = '0' }
      axios.put(globalConstants.apiURL + '/api/v1/users/' + this.user._id, {initiativeId: this.initiativeId, riskValue: val, index: 5})
      .then(response => {
        this.user.diagonactics = response.data.diagonactics
        window.localStorage.setItem('user', JSON.stringify(this.user))
      })
      .catch(error => {
        console.log(error)
      })
    },
    update7 (val) {
      this.budgetingandResourcing = val
      if (isNaN(val)) { val = '0' }
      axios.put(globalConstants.apiURL + '/api/v1/users/' + this.user._id, {initiativeId: this.initiativeId, riskValue: val, index: 6})
      .then(response => {
        this.user.diagonactics = response.data.diagonactics
        window.localStorage.setItem('user', JSON.stringify(this.user))
      })
      .catch(error => {
        console.log(error)
      })
    },
    update8 (val) {
      this.programmeDelivery = val
      if (isNaN(val)) { val = '0' }
      axios.put(globalConstants.apiURL + '/api/v1/users/' + this.user._id, {initiativeId: this.initiativeId, riskValue: val, index: 7})
      .then(response => {
        this.user.diagonactics = response.data.diagonactics
        window.localStorage.setItem('user', JSON.stringify(this.user))
      })
      .catch(error => {
        console.log(error)
      })
    },
    update9 (val) {
      this.businessRequirements = val
      if (isNaN(val)) { val = '0' }
      axios.put(globalConstants.apiURL + '/api/v1/users/' + this.user._id, {initiativeId: this.initiativeId, riskValue: val, index: 8})
      .then(response => {
        this.user.diagonactics = response.data.diagonactics
        window.localStorage.setItem('user', JSON.stringify(this.user))
      })
      .catch(error => {
        console.log(error)
      })
    },
    update10 (val) {
      this.organizationDesign = val
      if (isNaN(val)) { val = '0' }
      axios.put(globalConstants.apiURL + '/api/v1/users/' + this.user._id, {initiativeId: this.initiativeId, riskValue: val, index: 9})
      .then(response => {
        this.user.diagonactics = response.data.diagonactics
        window.localStorage.setItem('user', JSON.stringify(this.user))
      })
      .catch(error => {
        console.log(error)
      })
    },
    update11 (val) {
      this.changeReadiness = val
      if (isNaN(val)) { val = '0' }
      axios.put(globalConstants.apiURL + '/api/v1/users/' + this.user._id, {initiativeId: this.initiativeId, riskValue: val, index: 10})
      .then(response => {
        this.user.diagonactics = response.data.diagonactics
        window.localStorage.setItem('user', JSON.stringify(this.user))
      })
      .catch(error => {
        console.log(error)
      })
    },
    update12 (val) {
      this.implementationPlanning = val
      if (isNaN(val)) { val = '0' }
      axios.put(globalConstants.apiURL + '/api/v1/users/' + this.user._id, {initiativeId: this.initiativeId, riskValue: val, index: 11})
      .then(response => {
        this.user.diagonactics = response.data.diagonactics
        window.localStorage.setItem('user', JSON.stringify(this.user))
      })
      .catch(error => {
        console.log(error)
      })
    },
    update13 (val) {
      this.changeLeadership = val
      if (isNaN(val)) { val = '0' }
      axios.put(globalConstants.apiURL + '/api/v1/users/' + this.user._id, {initiativeId: this.initiativeId, riskValue: val, index: 12})
      .then(response => {
        this.user.diagonactics = response.data.diagonactics
        window.localStorage.setItem('user', JSON.stringify(this.user))
      })
      .catch(error => {
        console.log(error)
      })
    },
    update14 (val) {
      this.stakeholderEngagement = val
      if (isNaN(val)) { val = '0' }
      axios.put(globalConstants.apiURL + '/api/v1/users/' + this.user._id, {initiativeId: this.initiativeId, riskValue: val, index: 13})
      .then(response => {
        this.user.diagonactics = response.data.diagonactics
        window.localStorage.setItem('user', JSON.stringify(this.user))
      })
      .catch(error => {
        console.log(error)
      })
    },
    update15 (val) {
      this.implementationCapability = val
      if (isNaN(val)) { val = '0' }
      axios.put(globalConstants.apiURL + '/api/v1/users/' + this.user._id, {initiativeId: this.initiativeId, riskValue: val, index: 14})
      .then(response => {
        this.user.diagonactics = response.data.diagonactics
        window.localStorage.setItem('user', JSON.stringify(this.user))
      })
      .catch(error => {
        console.log(error)
      })
    },
    update16 (val) {
      this.supportPeoplesJournery = val
      if (isNaN(val)) { val = '0' }
      axios.put(globalConstants.apiURL + '/api/v1/users/' + this.user._id, {initiativeId: this.initiativeId, riskValue: val, index: 15})
      .then(response => {
        this.user.diagonactics = response.data.diagonactics
        window.localStorage.setItem('user', JSON.stringify(this.user))
      })
      .catch(error => {
        console.log(error)
      })
    }
  },
  created () {
    let user = JSON.parse(window.localStorage.getItem('user'))
    this.user = user
    this.isSubmitted = this.$store.state.assessmentCompleted
    axios.get(globalConstants.apiURL + '/api/v1/users/' + user._id)
    .then(response => {
      this.isSubmitted = response.data.diagonacticCompleted
      this.$store.commit('setAssessmentCompleted', response.data.diagonacticCompleted)
    })
    .catch(error => {
      if (error.response.status === 401) {
        this.logout()
      }
    })
    let currentInitiative = JSON.parse(window.localStorage.getItem('Initiative'))
    this.initiativeId = currentInitiative.id
    let diagonactic
    if (currentInitiative) {
      for (var i = 0; i < user.diagonactics.length; i++) {
        if (user.diagonactics[i].initiative === currentInitiative.id) {
          diagonactic = user.diagonactics[i]
          break
        }
      }
      if (diagonactic) {
        this.identifySponsor = diagonactic.risks[0] === '0' ? '' : diagonactic.risks[0]
        this.visionClarity = diagonactic.risks[1] === '0' ? '' : diagonactic.risks[1]
        this.sponsoringCoalition = diagonactic.risks[2] === '0' ? '' : diagonactic.risks[2]
        this.sponsorCapability = diagonactic.risks[3] === '0' ? '' : diagonactic.risks[3]
        this.governance = diagonactic.risks[4] === '0' ? '' : diagonactic.risks[4]
        this.programmeManagement = diagonactic.risks[5] === '0' ? '' : diagonactic.risks[5]
        this.budgetingandResourcing = diagonactic.risks[6] === '0' ? '' : diagonactic.risks[6]
        this.programmeDelivery = diagonactic.risks[7] === '0' ? '' : diagonactic.risks[7]
        this.businessRequirements = diagonactic.risks[8] === '0' ? '' : diagonactic.risks[8]
        this.organizationDesign = diagonactic.risks[9] === '0' ? '' : diagonactic.risks[9]
        this.changeReadiness = diagonactic.risks[10] === '0' ? '' : diagonactic.risks[10]
        this.implementationPlanning = diagonactic.risks[11] === '0' ? '' : diagonactic.risks[11]
        this.changeLeadership = diagonactic.risks[12] === '0' ? '' : diagonactic.risks[12]
        this.stakeholderEngagement = diagonactic.risks[13] === '0' ? '' : diagonactic.risks[13]
        this.implementationCapability = diagonactic.risks[14] === '0' ? '' : diagonactic.risks[14]
        this.supportPeoplesJournery = diagonactic.risks[15] === '0' ? '' : diagonactic.risks[15]
      } else {
      }
    }
    // randomize the steps
    function shuffle (array) {
      let currentIndex = array.length
      let temporaryValue
      let randomIndex
      // While there remain elements to shuffle...
      while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex -= 1
        // And swap it with the current element.
        temporaryValue = array[currentIndex]
        array[currentIndex] = array[randomIndex]
        array[randomIndex] = temporaryValue
      }
      return array
    }
    this.randomQuestion = shuffle([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16])
    this.step = this.randomQuestion[0] // show the initial random Q
  }
}
</script>

<style lang="scss" scoped>
.isActive {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.modal {
  top: 65px !important;
  height: 100%;
  @media screen and (max-width: 999px) {
    justify-content: flex-start;
    flex-direction: column;
    .modal-content {
      margin-top: 15%;
      max-height: calc(100vh - 160px) !important;
    }
  }
}
.successModal {
  .modal-content {
    border-radius: 10px;
    .box {
      .content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0px;
      }
      p {
        margin-bottom: 1rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// riskAssessment.vue?c84567fc